<template>
  <div class="ac-order-card ac-card-content">
    <div class="padding-default">
      <div class="flex-column align-start">
        <div class="sac__font-22">
          New Agreement Order
        </div>
        <div class="sac__font-14 margin-top-8">
          Orders include additional sensors or accessories only.
          For hardware kits and subscriptions, create a new agreement.
        </div>
      </div>
      <AgreementOrder hideTitle />
    </div>
    <div class="ac-footer-container">
      <div class="grid-column gap-16">
        <button
          type="button"
          class="sac__button bg-red"
          @click="discardOrder"
        >
          <span class="icon-luc-Trash2 sac__font-18 f-white" />
          <span>
            Discard
          </span>
        </button>
        <button
          type="button"
          :class="['sac__button bg-primary', !isValidShipment(newAgreement.agreementOrders[0]) ? 'disabled' : '']"
          :disabled="!isValidShipment(newAgreement.agreementOrders[0])"
          @click="createNewAgreementOrder"
        >
          Create
        </button>
      </div>
    </div>
    <ProcessOverlay
      :show="processing"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import partnerAgreementMixin from '@shared/mixins/partnerAgreementMixin';

import ProcessOverlay from '@shared/components/ProcessOverlay.vue';
import AgreementOrder from './AgreementOrder.vue';

export default {
  name: 'NewAgreementOrder',
  components: {
    AgreementOrder,
    ProcessOverlay,
  },
  mixins: [partnerAgreementMixin],
  props: {
    toggleActionModal: Function,
  },
  data() {
    return {
      processing: false,
    };
  },
  computed: {
    ...mapState({
      allBranchAddresses: (state) => state.partnerDetail.allBranchAddresses,
    }),
    addressOptions() {
      return this.allBranchAddresses.map((ad) => {
        const {
          company,
          address1,
          address2,
          city,
          state,
          zip,
        } = ad;
        const label = `${company}: ${address1}${address2 ? ` ${address2}` : ''}, ${city}, ${state} ${zip}`;
        return {
          label,
          value: ad.id,
        };
      });
    },
  },
  mounted() {
    if (this.allBranchAddresses.length === 0) {
      this.$store.dispatch('getAllBranchShippingAddress', this.agreement.corpId);
    }
  },
  methods: {
    discardOrder() {
      this.$store.dispatch('changePartnerAgreementValues', [{
        field: 'showActionModal',
        value: false,
      }]);
      this.$store.dispatch('resetNewAgreement');
    },
    async createNewAgreementOrder() {
      this.processing = true;
      try {
        await this.$store.dispatch('createNewAgreementOrder');
      } catch (err) {
        console.error(err);
      }
      this.processing = false;
    },
  },
};
</script>
